var chosenVariation = Math.floor(Math.random() * 2);

function getDomain() {
  var info = {};
  var hostParts = window.location.hostname.split('.');


  // localhost or some test name without zone,
  // not really production domain name
  if (hostParts.length == 1) {
    info.domain = hostParts[0];
  } else {
    info.currentSubdomain = hostParts.shift();
    info.domain = hostParts.join('.');
  }
  return info;
}

function setCookie(key, value) {
  var domain = getDomain();

  domain = domain.domain;

  if (domain !== 'localhost') {
    domain = '.' + domain;

  }
  // no expiration date so the cookie is set only to session length
  document.cookie = key + '=' + value + ';domain=' + domain + ';path=/;';
}

function getCookie(key) {
  if(document.cookie){
    var keyValue = document.cookie.match('(^|;) ?' + key + '=([^;]*)(;|$)');
    return keyValue && keyValue.length >= 3 ? keyValue[2] : null;
  }
  return null;
}

function variant(value, setCookieFlag) {
  // var heroClass = 'hero-var1';
  // var trackingValue = 'Man';
  var heroClass = 'home-page-hero';
  var trackingValue = 'Home Page Hero';
  var _paq = window._paq || [];

  if (parseInt(value) === 1) {
    // heroClass = 'hero-var4';
    // trackingValue = 'Woman';
    heroClass = 'home-page-hero';
    trackingValue = 'Home Page Hero';
  }

  // $('.hero.home-hero').removeClass('noBackground');
  $('.hero.home-hero').addClass(heroClass);
  _paq.push(['trackEvent', 'Image', trackingValue, 'visit']);
  _paq.push(['setCustomVariable', value, 'Hero Image', trackingValue, 'visit']);
  _paq.push(['trackPageView']);

  if (setCookieFlag === true) {
    var variation = JSON.parse(getCookie('variant')) || [];
    var abTestResult = {
      index: value,
      name: 'Hero Image',
      value: trackingValue,
      scope: 'visit',
    };
    variation.push(abTestResult);
    setCookie('variant', JSON.stringify(variation));
  }
}

$(document).ready(function() {
  if ($('#homepage').length) {
    if (getCookie('variant') !== null) {
      var value = JSON.parse(getCookie('variant'));
      // for this AB test - call it in particular only for Hero Image
      value.forEach(function(val) {
        if (val.name === 'Hero Image') {
          variant(val.index, false);
        }
      });
    } else {
      switch (chosenVariation) {
        case 0: {
          variant(0, true);
          break;
        }
        case 1: {
          variant(1, true);
          break;
        }
      }
    }
  }
});
